import React from 'react';
import replaceCommaWithDot from '../../../../helpers/utils/replaceCommaWithDot';
import formatCurrencyToLocal from '../../../../helpers/utils/formatCurrencyToLocal';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model;

    return (
        <React.Fragment>
            <div className="main-result">
                <p className="center-text monthly-payment">
                    {calc.l10n("CALCULATOR_MONTHLY_PAYMENT")}
                </p>
                <p className="monthly-payment-value center-text bold">{formatCurrencyToLocal(model.getRequiredPayment(), {style: 'currency', currency: 'UAH'})} <span className="asterix">*</span></p>
            </div>

            <div className={`loan-conditions`}>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_SUM')}</p>
                    <p className="bold">{formatCurrencyToLocal(model.getCreditSum(), {style: 'currency', currency: 'UAH'})}</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">
                        {calc.l10n('CALCULATOR_CREDIT_FORM')}
                    </p>
                    <p className="bold">{model.getCreditTerm()} {calc.l10n("CALCULATOR_MONTHS")}</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_INSTALLMENT_MONTH_COMISSION')}</p>
                    <p className="bold">{replaceCommaWithDot(model.getMonthCommission())}{calc.l10n('CALCULATOR_CREDIT_PERCENT')}</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_OVERPAYMENT')}</p>
                    <p className="bold">{formatCurrencyToLocal(model.getOverpayment(), {style: 'currency', currency: 'UAH'})}</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_REAL_INTEREST_RATE')}</p>
                    <p className="bold">{model.getRealInterestRate()}%</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_TOTAL_COST')}</p>
                    <p className="bold">{formatCurrencyToLocal(model.getCreditCost(), {style: 'currency', currency: 'UAH'})}</p>
                </div>
            </div>
            <div className="line" />
            <div className="disclaimer">{calc.l10n('CALCULATOR_DISCLAIMER')}</div>
        </React.Fragment>
    );
}
